import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const CARD_PRESENT: PaymentMethod = {
    id: PAYMENT_METHOD_ID.CardPresent,
    name: 'cardpresent',
    tokenRequired: true
};
